(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9190],{

/***/ 40302:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart",
      function () {
        return __webpack_require__(10825);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ cart; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/hooks/useCartDiscountPrices.js
var useCartDiscountPrices = __webpack_require__(4911);
// EXTERNAL MODULE: ./src/snippets/cart/Cart.module.css
var Cart_module = __webpack_require__(41922);
var Cart_module_default = /*#__PURE__*/__webpack_require__.n(Cart_module);
;// CONCATENATED MODULE: ./src/snippets/cart/CartEmpty.jsx



function CartEmpty(props) {
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var cartPage = (settings === null || settings === void 0 ? void 0 : settings.cartPage) || {};
    var emptyMsg = (cartPage === null || cartPage === void 0 ? void 0 : cartPage.cartEmptyMessage) || "Oops! Your cart is currently empty.";
    var ctaTitle = (cartPage === null || cartPage === void 0 ? void 0 : (ref = cartPage.cta) === null || ref === void 0 ? void 0 : ref.title) || "continue shopping";
    var ctaUrl = (cartPage === null || cartPage === void 0 ? void 0 : (ref1 = cartPage.cta) === null || ref1 === void 0 ? void 0 : ref1.url) || "/";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cart__empty pt-16 pb-[250px] text-center lg:pt-[150px] lg:pt-[170px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "h2 mb-13 mt-0",
                children: emptyMsg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: ctaUrl,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "button button--outline inline-block no-underline",
                        children: ctaTitle
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var cart_CartEmpty = (CartEmpty);

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/snippets/index.js + 13 modules
var snippets = __webpack_require__(91588);
// EXTERNAL MODULE: ./src/utilities/Images.js
var Images = __webpack_require__(80152);
// EXTERNAL MODULE: ./src/utilities/Helper.js
var Helper = __webpack_require__(41717);
// EXTERNAL MODULE: ../node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31655);
;// CONCATENATED MODULE: ./src/snippets/cart/CartItem.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









function CartItem(param) {
    var item = param.item, cartUpdateItem = param.cartUpdateItem, cartRemoveItem = param.cartRemoveItem, isUs = param.isUs;
    var ref46, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
    var siteSettings = (0,dist.useSettings)();
    var country = (0,dist.useCountry)().country;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var isFreeItem = item.attributes.some(function(attr) {
        return [
            "_gwp"
        ].includes(attr.key);
    });
    var product = (0,dist.useProductByHandle)({
        handle: item === null || item === void 0 ? void 0 : (ref46 = item.variant) === null || ref46 === void 0 ? void 0 : (ref1 = ref46.product) === null || ref1 === void 0 ? void 0 : ref1.handle
    }).product;
    var sellingPlans = product === null || product === void 0 ? void 0 : (ref2 = product.sellingPlanGroups) === null || ref2 === void 0 ? void 0 : ref2.filter(function(group) {
        return (group === null || group === void 0 ? void 0 : group.appName) == "294517";
    });
    var hasSellingPlan = item === null || item === void 0 ? void 0 : item.sellingPlanAllocation;
    var planAmount = item === null || item === void 0 ? void 0 : (ref3 = item.sellingPlanAllocation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.priceAdjustments) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.price) === null || ref6 === void 0 ? void 0 : ref6.amount;
    var planText = item === null || item === void 0 ? void 0 : (ref7 = item.sellingPlanAllocation) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sellingPlan) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.name) === null || ref9 === void 0 ? void 0 : ref9.replace(/Delivery/i, "Ships");
    var planPrice = planAmount ? parseFloat(planAmount) : null;
    var planOptions = sellingPlans === null || sellingPlans === void 0 ? void 0 : sellingPlans.map(function(plan) {
        var ref, ref42, ref43, ref44, ref45;
        return {
            label: plan === null || plan === void 0 ? void 0 : (ref = plan.sellingPlans) === null || ref === void 0 ? void 0 : (ref42 = ref[0]) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.name) === null || ref43 === void 0 ? void 0 : ref43.replace("Delivery", "Deliver"),
            value: plan === null || plan === void 0 ? void 0 : (ref44 = plan.sellingPlans) === null || ref44 === void 0 ? void 0 : (ref45 = ref44[0]) === null || ref45 === void 0 ? void 0 : ref45.id
        };
    });
    var sellingPlanOptions = (planOptions === null || planOptions === void 0 ? void 0 : planOptions.length) ? [
        {
            label: "One-time Purchase",
            value: "one-time"
        }
    ].concat(_toConsumableArray(planOptions)) : [];
    var ref41 = (0,dist.useLocalizedVariant)({
        variant: item.variant
    }), localizedVariant = ref41.localized;
    var hasDiscount = Number.parseFloat(item.estimatedCost.subtotalAmount.amount) !== Number.parseFloat(item.estimatedCost.totalAmount.amount);
    var selectedVariant = _objectSpread({}, item.variant, localizedVariant);
    var variantAmount = item.estimatedCost.totalAmount.amount / item.quantity;
    var compareAmount = hasDiscount ? Number.parseFloat(item.estimatedCost.subtotalAmount.amount) / item.quantity : Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref10 = selectedVariant.compareAtPriceV2) === null || ref10 === void 0 ? void 0 : ref10.amount);
    if (hasSellingPlan) compareAmount = Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref11 = selectedVariant.compareAtPriceV2) === null || ref11 === void 0 ? void 0 : ref11.amount) || Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.priceV2) === null || ref12 === void 0 ? void 0 : ref12.amount);
    if (compareAmount < Number.parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref13 = selectedVariant.compareAtPriceV2) === null || ref13 === void 0 ? void 0 : ref13.amount)) compareAmount = Number.parseFloat(selectedVariant.compareAtPriceV2.amount);
    var currencySymbol = country === null || country === void 0 ? void 0 : (ref14 = country.currency) === null || ref14 === void 0 ? void 0 : ref14.symbol;
    var comparePrice = compareAmount ? compareAmount : null;
    var variantPrice = variantAmount;
    var handlePlanChange = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(e.target.value === "one-time")) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 3;
                        return cartRemoveItem({
                            lineId: item.id
                        });
                    case 3:
                        _ctx.next = 5;
                        return cartAddItem({
                            merchandiseId: item.variant.id,
                            quantity: item.quantity,
                            attributes: [
                                {
                                    key: "_sc",
                                    value: typeof window.ShipScoutLineItemProperty !== "undefined" ? window.ShipScoutLineItemProperty : "null"
                                }
                            ]
                        });
                    case 5:
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.next = 9;
                        return cartUpdateItem({
                            lineId: item.id,
                            sellingPlanId: btoa(e.target.value)
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlanChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var upgradeToPlan = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref47, firstPlan;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        firstPlan = sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref = sellingPlans[0]) === null || ref === void 0 ? void 0 : (ref47 = ref.sellingPlans) === null || ref47 === void 0 ? void 0 : ref47[0];
                        if (!firstPlan) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return cartUpdateItem({
                            lineId: item.id,
                            sellingPlanId: btoa(firstPlan === null || firstPlan === void 0 ? void 0 : firstPlan.id)
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function upgradeToPlan() {
            return _ref.apply(this, arguments);
        };
    }();
    var calcDiscountValue = function() {
        var discountValue = null;
        var currentAmount = variantAmount;
        if (planPrice) {
            currentAmount = parseFloat(item.estimatedCost.totalAmount.amount) < parseFloat(planPrice) ? parseFloat(item.estimatedCost.totalAmount.amount) : parseFloat(planPrice);
        }
        if (compareAmount) {
            discountValue = (compareAmount - currentAmount) / compareAmount * 100;
            discountValue = Math.round(discountValue).toFixed(0);
        }
        return discountValue;
    };
    var discountValue1 = calcDiscountValue();
    var discountHighlight = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref15 = siteSettings.discountHighlight) === null || ref15 === void 0 ? void 0 : ref15.enableDiscountHighlight) && discountValue1 !== 0 && discountValue1 !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(isFreeItem ? "free-item-line-item-container items-start" : "items-center", " cart-items-container border-b border-grey-4 px-4 py-6 lg:px-0 lg:py-7"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between ".concat(isFreeItem ? "items-start" : "items-center", " px-4 py-6 lg:px-0 lg:py-7"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[90px] shrink-0 self-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(isFreeItem ? "" : "/products/${item?.variant?.product?.handle"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "responsive-image pb-full bg-grey-9 ".concat(isFreeItem ? "pointer-events-none" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,Images/* getSizedImageUrl */.M0)(item === null || item === void 0 ? void 0 : (ref16 = item.variant) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.image) === null || ref17 === void 0 ? void 0 : ref17.src, "100x115@2x"),
                                    alt: item === null || item === void 0 ? void 0 : (ref18 = item.variant) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.product) === null || ref19 === void 0 ? void 0 : ref19.title,
                                    width: "100",
                                    height: "115"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex-grow px-4 lg:pl-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(isFreeItem ? "" : "/products/".concat(item === null || item === void 0 ? void 0 : (ref20 = item.variant) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.product) === null || ref21 === void 0 ? void 0 : ref21.handle)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "my-0 pr-6 font-gothamBold text-xs lg:pr-0 ".concat(isFreeItem ? "pointer-events-none" : ""),
                                    children: item === null || item === void 0 ? void 0 : (ref22 = item.variant) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.product) === null || ref23 === void 0 ? void 0 : ref23.title
                                })
                            }),
                            (item === null || item === void 0 ? void 0 : (ref24 = item.variant) === null || ref24 === void 0 ? void 0 : ref24.title) !== "Default Title" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 mt-0 text-xs lg:mt-2",
                                children: item === null || item === void 0 ? void 0 : (ref25 = item.variant) === null || ref25 === void 0 ? void 0 : ref25.title
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mr-[15px] max-w-[320px] md:mr-[60px]",
                                children: [
                                    planText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mb-0 mt-1 text-xs lowercase",
                                        children: [
                                            "".concat(planText),
                                            discountHighlight && discountValue1 > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "lineItem__discount-percentage ml-1 inline-block rounded-sm border border-solid border-primary-2 px-1 py-[1px] font-gothamBold text-sub-xx-small text-primary-2",
                                                children: [
                                                    discountValue1,
                                                    "% off"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mb-0 mt-1 text-xs lowercase",
                                        children: [
                                            "One-time Purchase",
                                            discountHighlight && discountValue1 > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "lineItem__discount-percentage ml-1 inline-block rounded-sm border border-solid border-primary-2 px-1 py-[1px] font-gothamBold text-sub-xx-small text-primary-2",
                                                children: [
                                                    discountValue1,
                                                    "% off"
                                                ]
                                            })
                                        ]
                                    }),
                                    hasSellingPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "select-wrap-3 relative flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            className: "mt-[16px] h-[40px] w-auto cursor-pointer border border-grey-5 px-3 py-2 pr-[45px] text-[12px] text-black placeholder-black outline-0 transition-all placeholder-shown:border-grey-5 hover:border-black hover:placeholder-black focus:placeholder-black",
                                            name: "selling-plan-select-".concat(item === null || item === void 0 ? void 0 : item.id),
                                            id: "selling-plan-select-".concat(item === null || item === void 0 ? void 0 : item.id),
                                            value: item === null || item === void 0 ? void 0 : (ref26 = item.sellingPlanAllocation) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.sellingPlan) === null || ref27 === void 0 ? void 0 : ref27.id,
                                            onChange: handlePlanChange,
                                            children: sellingPlanOptions === null || sellingPlanOptions === void 0 ? void 0 : sellingPlanOptions.map(function(option, optionIndex) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: option.value,
                                                    children: option.label
                                                }, "option-".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(optionIndex));
                                            })
                                        })
                                    }),
                                    !hasSellingPlan && sellingPlans && isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "cart-upgrade-sub mt-5 hidden cursor-pointer whitespace-nowrap border-b-2 font-gothamBold text-sm md:inline-block",
                                        onClick: upgradeToPlan,
                                        children: (sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref28 = sellingPlans[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.priceAdjustments) === null || ref29 === void 0 ? void 0 : (ref30 = ref29[0]) === null || ref30 === void 0 ? void 0 : ref30.adjustmentValue) ? "update to subscription & save ".concat(sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref31 = sellingPlans[0]) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.priceAdjustments) === null || ref32 === void 0 ? void 0 : (ref33 = ref32[0]) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.adjustmentValue) === null || ref34 === void 0 ? void 0 : ref34.adjustmentPercentage, "%") : "update to subscription"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-6 flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemQuantity, {
                                                isFreeItem: isFreeItem,
                                                cartUpdateItem: cartUpdateItem,
                                                cartRemoveItem: cartRemoveItem,
                                                item: item
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTotal, {
                                                className: "text-right text-sm",
                                                isFreeItem: isFreeItem,
                                                comparePrice: comparePrice,
                                                planPrice: planPrice,
                                                variantPrice: variantPrice,
                                                currencySymbol: currencySymbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "".concat((Cart_module_default()).lineItemDelete, " free? absolute right-0 top-0 inline-block cursor-pointer"),
                                        onClick: function() {
                                            cartRemoveItem({
                                                lineId: item.id
                                            });
                                            if (item.attributes.find(function(attribute) {
                                                return attribute.key === "_gwp";
                                            })) {
                                                var ref;
                                                var optedOutCampaigns = ((ref = js_cookie/* default.get */.Z.get("OptedOutCampaigns")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
                                                var campaign = item.attributes.find(function(attribute) {
                                                    return attribute.key === "_campaign";
                                                }).value;
                                                js_cookie/* default.set */.Z.set("OptedOutCampaigns", _toConsumableArray(optedOutCampaigns).concat([
                                                    campaign, 
                                                ]));
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-lg:hidden lg:flex lg:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemQuantity, {
                                className: "w-28",
                                isFreeItem: isFreeItem,
                                cartUpdateItem: cartUpdateItem,
                                cartRemoveItem: cartRemoveItem,
                                item: item
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTotal, {
                                className: "w-28 shrink-0 text-center text-sm",
                                isFreeItem: isFreeItem,
                                comparePrice: comparePrice,
                                planPrice: planPrice,
                                variantPrice: variantPrice,
                                currencySymbol: currencySymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-20 shrink-0 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "".concat((Cart_module_default()).lineItemDelete, " inline-block cursor-pointer"),
                                    onClick: function() {
                                        cartRemoveItem({
                                            lineId: item.id
                                        });
                                        if (item.attributes.find(function(attribute) {
                                            return attribute.key === "_gwp";
                                        })) {
                                            var ref;
                                            var optedOutCampaigns = ((ref = js_cookie/* default.get */.Z.get("OptedOutCampaigns")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
                                            var campaign = item.attributes.find(function(attribute) {
                                                return attribute.key === "_campaign";
                                            }).value;
                                            js_cookie/* default.set */.Z.set("OptedOutCampaigns", _toConsumableArray(optedOutCampaigns).concat([
                                                campaign, 
                                            ]));
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                                })
                            })
                        ]
                    })
                ]
            }),
            !hasSellingPlan && sellingPlans && isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full px-4 text-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "cart-upgrade-sub mx-auto mt-0 inline-block cursor-pointer border-b-2 font-gothamBold text-sm md:hidden md:whitespace-nowrap",
                    onClick: upgradeToPlan,
                    children: "update to subscription & save ".concat(sellingPlans === null || sellingPlans === void 0 ? void 0 : (ref35 = sellingPlans[0]) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.sellingPlans) === null || ref36 === void 0 ? void 0 : (ref37 = ref36[0]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.priceAdjustments) === null || ref38 === void 0 ? void 0 : (ref39 = ref38[0]) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.adjustmentValue) === null || ref40 === void 0 ? void 0 : ref40.adjustmentPercentage, "%")
                })
            })
        ]
    });
}
function ItemQuantity(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, isFreeItem = param.isFreeItem, cartUpdateItem = param.cartUpdateItem, cartRemoveItem = param.cartRemoveItem, item = param.item;
    if (isFreeItem) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " rounded-xs flex justify-between border border-black"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "flex cursor-pointer items-center pl-3",
                onClick: function() {
                    if (item.quantity === 1) {
                        cartRemoveItem({
                            lineId: item.id
                        });
                        return;
                    }
                    cartUpdateItem({
                        lineId: item.id,
                        quantity: item.quantity - 1
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconMinus */.Ur, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "flex-grow py-2 px-4 text-center",
                children: item.quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "flex cursor-pointer items-center pr-3 ".concat(item.quantity >= 5 ? "pointer-events-none opacity-50" : ""),
                onClick: function() {
                    if (item.quantity >= 5) return;
                    cartUpdateItem({
                        lineId: item.id,
                        quantity: item.quantity + 1
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconPlus */.SC, {})
            })
        ]
    });
}
function ItemTotal(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, isFreeItem = param.isFreeItem, comparePrice = param.comparePrice, planPrice = param.planPrice, variantPrice = param.variantPrice, currencySymbol = param.currencySymbol;
    if (isFreeItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((Cart_module_default()).lineItemPricing, " ").concat(className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Cart_module_default()).lineItemPrice,
                children: "FREE"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Cart_module_default()).lineItemPricing, " ").concat(className),
        children: [
            comparePrice > variantPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Cart_module_default()).lineItemCompareAtPrice,
                children: (0,Helper/* formatMoney */.lb)(comparePrice.toFixed(2)).replace("$", currencySymbol)
            }) : null,
            planPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Cart_module_default()).lineItemPrice,
                children: (0,Helper/* formatMoney */.lb)(planPrice === null || planPrice === void 0 ? void 0 : planPrice.toFixed(2)).replace("$", currencySymbol)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Cart_module_default()).lineItemPrice,
                children: (0,Helper/* formatMoney */.lb)(variantPrice.toFixed(2)).replace("$", currencySymbol)
            })
        ]
    });
}
/* harmony default export */ var cart_CartItem = (CartItem);

// EXTERNAL MODULE: ./src/snippets/cart/GWPHandler.jsx
var GWPHandler = __webpack_require__(50954);
// EXTERNAL MODULE: ./src/snippets/beam/BeamNonprofitWidget.jsx
var BeamNonprofitWidget = __webpack_require__(38839);
// EXTERNAL MODULE: ./src/snippets/components/Image/index.js + 2 modules
var Image = __webpack_require__(69342);
;// CONCATENATED MODULE: ./src/snippets/cart/CartBundleItem.jsx
function CartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CartBundleItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CartBundleItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function CartBundleItem(param) {
    var item = param.item;
    var cartRemoveItems = (0,dist.useCartRemoveItems)().cartRemoveItems;
    var discountValue = item.attributes.find(function(attribute) {
        return attribute.key === "_discount";
    }).value;
    var country = (0,dist.useCountry)().country;
    var currencySimbol = (country === null || country === void 0 ? void 0 : country.currency.symbol) || "$";
    var removeBundle = function() {
        var _ref = CartBundleItem_asyncToGenerator(runtime_default().mark(function _callee() {
            var lineItemsId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        lineItemsId = item.bundleItems.map(function(bundleItem) {
                            return bundleItem.id;
                        });
                        _ctx.next = 3;
                        return cartRemoveItems({
                            lineIds: lineItemsId
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeBundle() {
            return _ref.apply(this, arguments);
        };
    }();
    var buildBundleItems = function() {
        var bundleItems = item.bundleItems.map(function(bundleItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-bundle-item__product flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cart-bundle-item__product-image w-[90px] shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: bundleItem.variant.image.src,
                            alt: bundleItem.variant.image.altText,
                            width: 90,
                            height: 90,
                            sizes: "10vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cart-bundle-item__product-details pl-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cart-bundle-item__product-title font-gothamBold text-xs",
                            children: bundleItem.variant.product.title
                        })
                    })
                ]
            }, bundleItem.id);
        });
        return bundleItems;
    };
    var bundleFullPrice = item.bundleItems.reduce(function(acc, bundleItem) {
        return acc + Number.parseFloat(bundleItem.estimatedCost.subtotalAmount.amount);
    }, 0);
    var bundleDiscountedPrice = item.bundleItems.reduce(function(acc, bundleItem) {
        return acc + Number.parseFloat(bundleItem.estimatedCost.totalAmount.amount);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-items-container border-b border-grey-4 py-6 px-4 lg:py-7 lg:px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cart-item__bundle flex flex-wrap px-4 py-6 lg:py-7 lg:px-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cart-bundle-item__header relative w-full pr-8 pb-4 font-gothamBold text-sm lg:pr-0",
                    children: [
                        "Bundled Items",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "relative top-[-1px] ml-1 inline-block rounded-sm border border-solid border-primary-2 px-1 font-gothamBold text-sub-xx-small text-primary-2",
                            children: [
                                discountValue,
                                "% off"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: removeBundle,
                            className: "absolute top-0 right-0 lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cart-bundle-item__body flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cart-bundle-item__products grid grid-cols-1 gap-x-2 gap-y-5 lg:grid-cols-2",
                            children: buildBundleItems()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cart-bundle-item__details hidden flex-shrink-0 items-center text-center lg:block lg:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cart-bundle-item__count w-28",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mx-auto inline-block border border-grey-4 py-2 px-4 text-center",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cart-bundle-item__price w-28",
                                    children: [
                                        bundleFullPrice > bundleDiscountedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            className: "cart-bundle-item__full-price font-gothamBold text-sm text-grey-3",
                                            children: (0,Helper/* formatMoney */.lb)(bundleFullPrice.toFixed(2)).replace("$", currencySimbol)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cart-bundle-item__discounted-price font-gothamBold text-sm",
                                            children: (0,Helper/* formatMoney */.lb)(bundleDiscountedPrice.toFixed(2)).replace("$", currencySimbol)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cart-bundle-item__remove w-20 leading-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: removeBundle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* IconRemove */.HF, {})
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cart-bundle-item__footer-body flex w-full lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-bundle-item__details flex w-full flex-shrink-0 items-center pl-[110px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-bundle-item__count w-28",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-auto inline-block border border-grey-4 py-2 px-4 text-center",
                                    children: "1"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cart-bundle-item__price flex w-full flex-wrap justify-end gap-2",
                                children: [
                                    bundleFullPrice > bundleDiscountedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                        className: "cart-bundle-item__full-price font-gothamBold text-sm text-grey-3",
                                        children: (0,Helper/* formatMoney */.lb)(bundleFullPrice.toFixed(2)).replace("$", currencySimbol)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-bundle-item__discounted-price inline-block font-gothamBold text-sm",
                                        children: (0,Helper/* formatMoney */.lb)(bundleDiscountedPrice.toFixed(2)).replace("$", currencySimbol)
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/snippets/cart/Cart.jsx
function Cart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Cart_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Cart_arrayLikeToArray(arr);
}
function Cart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Cart_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Cart_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Cart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Cart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Cart_toConsumableArray(arr) {
    return Cart_arrayWithoutHoles(arr) || Cart_iterableToArray(arr) || Cart_unsupportedIterableToArray(arr) || Cart_nonIterableSpread();
}
function Cart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Cart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cart_arrayLikeToArray(o, minLen);
}












function Cart() {
    var ref16, ref1, ref2, ref3, ref4, ref5, ref6;
    var siteSettings = (0,dist.useSettings)();
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartTotals = (0,dist.useCartTotals)();
    var discountAmount = (0,useCartDiscountPrices/* useCartDiscountPrices */.P)().discountAmount;
    var cartCheckout = (0,dist.useCartCheckout)().cartCheckout;
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var lines = (ref16 = Cart_toConsumableArray((cart === null || cart === void 0 ? void 0 : cart.lines) || [])) === null || ref16 === void 0 ? void 0 : ref16.sort(function(a, b) {
        var isFreeA = a.attributes.some(function(attr) {
            return [
                "_gwp",
                "_sample"
            ].includes(attr.key);
        });
        var isFreeB = b.attributes.some(function(attr) {
            return [
                "_gwp",
                "_sample"
            ].includes(attr.key);
        });
        return isFreeA === isFreeB ? 0 : isFreeA ? 1 : -1;
    });
    var hasBundleItems = lines.some(function(line) {
        return line.attributes.find(function(attr) {
            return attr.key === "_bundleId";
        });
    });
    if (hasBundleItems) {
        // Morphs the lines to identify bundle items
        lines = lines.map(function(line, index) {
            var newLine = Cart_objectSpread({}, line);
            if (line.attributes.find(function(attr) {
                return attr.key === "_bundleId";
            })) {
                var bundleItemsCount = newLine.attributes.find(function(attr) {
                    return attr.key === "_bundleCount";
                }).value;
                newLine.isBundle = true;
                newLine.bundleItems = cart === null || cart === void 0 ? void 0 : cart.lines.filter(function(lineItem) {
                    return lineItem.attributes.some(function(attr) {
                        return attr.key === "_bundleId";
                    });
                });
            }
            return newLine;
        });
    }
    var cartSummary = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(false), summarySticky = ref7[0], setSummarySticky = ref7[1];
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var currencySymbol = (country === null || country === void 0 ? void 0 : (ref1 = country.currency) === null || ref1 === void 0 ? void 0 : ref1.symbol) || "$";
    var buildCartItems = function() {
        var skipItem = 0;
        var newLines = lines.map(function(item, index) {
            if (skipItem > 0) {
                skipItem -= 1;
                return null;
            }
            if (item.isBundle) {
                skipItem = item.bundleItems.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBundleItem, {
                    item: item
                }, "lineItem-".concat(index));
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_CartItem, {
                item: item,
                cartRemoveItem: cartRemoveItem,
                cartUpdateItem: cartUpdateItem,
                isUs: isUs
            }, "lineItem-".concat(index));
        });
        return newLines;
    };
    (0,react.useEffect)(function() {
        var handleScroll = function(evt) {
            if (cartSummary.current) {
                var bounds = cartSummary.current.getBoundingClientRect();
                var viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                var scrollY = window.scrollY;
                setSummarySticky(bounds.top >= viewHeight);
                window.lastSpot = scrollY;
            }
        };
        window.scrollTo(0, 1);
        if (!window.lastSpot) window.lastSpot = window.scrollY;
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var compareAtPriceTotal = cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(accumulator, cartItem) {
        var ref, ref8, ref9, ref10, ref11, ref12, ref13;
        var compareAmount = parseFloat(!!(cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.variant) === null || ref === void 0 ? void 0 : (ref8 = ref.compareAtPriceV2) === null || ref8 === void 0 ? void 0 : ref8.amount) && (cartItem === null || cartItem === void 0 ? void 0 : (ref9 = cartItem.variant) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.compareAtPriceV2) === null || ref10 === void 0 ? void 0 : ref10.amount) !== "0.0" ? cartItem === null || cartItem === void 0 ? void 0 : (ref11 = cartItem.variant) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.compareAtPriceV2) === null || ref12 === void 0 ? void 0 : ref12.amount : cartItem === null || cartItem === void 0 ? void 0 : (ref13 = cartItem.variant) === null || ref13 === void 0 ? void 0 : ref13.priceV2.amount) * cartItem.quantity;
        if ((cartItem === null || cartItem === void 0 ? void 0 : cartItem.sellingPlanAllocation) && compareAmount == 0) {
            var ref14, ref15;
            compareAmount = parseFloat(cartItem === null || cartItem === void 0 ? void 0 : (ref14 = cartItem.variant) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.priceV2) === null || ref15 === void 0 ? void 0 : ref15.amount) * cartItem.quantity;
        }
        return accumulator += compareAmount;
    }, 0);
    var discountHighlight = (siteSettings === null || siteSettings === void 0 ? void 0 : (ref3 = siteSettings.discountHighlight) === null || ref3 === void 0 ? void 0 : ref3.enableDiscountHighlight) === true && (siteSettings === null || siteSettings === void 0 ? void 0 : (ref4 = siteSettings.discountHighlight) === null || ref4 === void 0 ? void 0 : ref4.cartDiscountMessage) !== "" && compareAtPriceTotal - (cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) + discountAmount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            cartCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Cart_module_default()).cart,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 xl:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "focus-link inline-block text-sm",
                                    children: "continue shopping"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "h2 my-4 xl:mt-5 xl:mb-6",
                                children: "Your Cart"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Cart_module_default()).cartBody),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Cart_module_default()).cartItems, " pr-0 xl:pr-8 xl:pr-20"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "hidden items-center justify-between border-t border-b border-black py-4 text-center font-gothamBold text-h6 xl:flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-grow text-left",
                                                children: "Product"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-28 shrink-0",
                                                children: "Qty"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-28 shrink-0",
                                                children: "Total"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-20 shrink-0"
                                            })
                                        ]
                                    }),
                                    buildCartItems(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPHandler/* GWPHandler */.e, {
                                        gwpItems: [],
                                        cartLines: lines,
                                        cartView: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BeamNonprofitWidget/* default */.Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full max-w-full flex-shrink-0 xl:w-[375px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((Cart_module_default()).cartSummary, " text-sm"),
                                    ref: cartSummary,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "m-0 border-b border-black pb-3 text-center font-gothamBold text-sm",
                                            children: [
                                                "Order summary (",
                                                cartCount,
                                                " items)",
                                                " "
                                            ]
                                        }),
                                        discountHighlight && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-4 flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "pr-4",
                                                            children: "Before Savings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: (ref5 = (0,Helper/* formatMoney */.lb)(compareAtPriceTotal.toFixed(2))) === null || ref5 === void 0 ? void 0 : ref5.replace("$", currencySymbol)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-4 flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "pr-4",
                                                            children: siteSettings === null || siteSettings === void 0 ? void 0 : (ref6 = siteSettings.discountHighlight) === null || ref6 === void 0 ? void 0 : ref6.cartDiscountMessage
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-primary-2",
                                                            children: [
                                                                "- ",
                                                                (0,Helper/* formatMoney */.lb)((compareAtPriceTotal - (cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) + discountAmount).toFixed(2)).replace("$", currencySymbol)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pr-4",
                                                    children: "Subtotal"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,Helper/* formatMoney */.lb)(((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) - discountAmount || 0).toFixed(2)).replace("$", currencySymbol)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pr-4",
                                                    children: "Shipping*"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "TBD"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pr-4",
                                                    children: "Taxes*"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "TBD"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center justify-between border-t border-black pt-3 font-gothamBold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pr-4",
                                                    children: "Order Total"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,Helper/* formatMoney */.lb)(((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) - discountAmount).toFixed(2) || 0).replace("$", currencySymbol)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "button button--checkout w-full",
                                                onClick: cartCheckout,
                                                children: "checkout"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "whitespace-normal pt-4 text-center xl:pt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs",
                                                children: "*Shipping & Taxes Calculated at Checkout"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Cart_module_default()).cartSummarySticky, " ").concat(summarySticky ? (Cart_module_default())["is-active"] : "", " text-sm"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between font-gothamBold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-4",
                                        children: "Subtotal"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "".concat(currencySymbol).concat(((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) - discountAmount || 0).toFixed(2).replace(".00", ""))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "button button--checkout w-full",
                                    onClick: cartCheckout,
                                    children: "checkout"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "whitespace-normal pt-2 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-xs",
                                    children: "Any discounts, shipping & taxes calculated at checkout"
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            cartCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_CartEmpty, {}) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/cart/index.js


;// CONCATENATED MODULE: ./src/pages/cart.jsx


function CartPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart px-0 lg:px-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "m-auto lg:container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {})
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var cart = (CartPage);


/***/ }),

/***/ 41922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart":"Cart_cart__drr5j","cartBody":"Cart_cartBody__9YVvq","cartItems":"Cart_cartItems___pKHl","lineItemDelete":"Cart_lineItemDelete__xOfds","lineItemPricing":"Cart_lineItemPricing__y_61M","lineItemCompareAtPrice":"Cart_lineItemCompareAtPrice___aqua","lineItemPrice":"Cart_lineItemPrice__s8CbK","cartSummary":"Cart_cartSummary__JCuHs","cartSummarySticky":"Cart_cartSummarySticky__DApME","is-active":"Cart_is-active__PsOpg"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(40302); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);